"use client";

import { createTheme, Snackbar, Alert, ThemeProvider } from "@mui/material";
import { CustomPaletteMode, getTheme } from "@/utils/theme";
import useSnackBarStore from "../stores/snackbarStore";
import { useSelect } from "@/context/ContextSelector";
import GlobalNotificationManager from "@/components/GlobalNotificationManager";
import { PasswordUpdateRequiredDialog } from "@/components/dialog/PasswordUpdateRequiredDialog";
import { useSession } from "next-auth/react";
import { useState, useEffect } from "react";

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { setSnackBar, snackBar } = useSnackBarStore();
  const { contextValue } = useSelect();
  const theme = createTheme(getTheme(contextValue as CustomPaletteMode));
  const handleClose = () => setSnackBar(false);
  const { data: session } = useSession() as any;
  const [showPasswordUpdate, setShowPasswordUpdate] = useState<boolean>(false);

  useEffect(() => {
    if (session?.user) {
      const passwordPolicyCompliant = session.user.passwordPolicyCompliant;

      if (passwordPolicyCompliant === "false") {
        setShowPasswordUpdate(true);
      }
    }
  }, [session]);
  return (
    <ThemeProvider theme={theme}>
      {/* <CssBaseline /> TODO a quoi sert ça ?*/}
      <GlobalNotificationManager />
      {children}
      <PasswordUpdateRequiredDialog
        open={showPasswordUpdate}
        setOpen={setShowPasswordUpdate}
      />
      <Snackbar
        open={snackBar.isOpen}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={snackBar.severity}>
          {snackBar.message}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}
